// @mui
import Container from '@mui/material/Container';
import { useSettingsContext } from 'src/components/settings';
import Timeline2 from './timeline2';
// ----------------------------------------------------------------------
export default function MarketingTimeline() {
  const settings = useSettingsContext();
  return (
    <Container maxWidth={ settings.themeStretch ? false : 'xl' }>
      <Timeline2 />
    </Container>
  );
}
